import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl, AbstractControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CustomValidators } from 'ng2-validation';
import { ToastrService } from 'ngx-toastr';
import { RoomenquiryService } from '../../shared/Services/roomenquiry/roomenquiry.service';
import { formatDate } from '@angular/common';

@Component({
  selector: 'app-roomenquiry',
  templateUrl: './roomenquiry.component.html',
  styleUrls: ['./roomenquiry.component.css']
})
export class RoomenquiryComponent implements OnInit 
{

 form: FormGroup<any> = new FormGroup({
  bookingype: new FormControl(''),
  roomcategytype: new FormControl(''),
  typesofrooms:new FormControl(''),
  noofguests:new FormControl(''),
  noofmonths:new FormControl('')

   
  });

  typeofbooking:any;
  submitted = false;
   bookingprice:any;
  finalprice:any;
  isSubmitted = false;
  extraamounts:any;
  isroomtypes:boolean = false;
  strClientid:any;
  isLoading: boolean = false;
  constructor(private apiService: RoomenquiryService,private fb: FormBuilder, private route: ActivatedRoute, private router: Router, private toastr: ToastrService)

  {
    this.finalprice=0;
    this.extraamounts=0;
   }


  ngOnInit()
  {
    this.form = this.fb.group({
      bookingype: ['', ''],
      roomcategytype: ['',''],
      typesofrooms: ['', ''],
      noofguests:['',''],
      noofmonths:['',''],
      gender: ['', [Validators.required]]
     
     
    });

    this.isLoading = false;
    sessionStorage['ClientId']="1";

    this.strClientid=sessionStorage['ClientId'];
   // this.strClientid="1";
    this.getbyFacilitiesid(this.strClientid);
    this.Getroomscategories(this.strClientid);
    
    this.bookingprice=0;
    this.finalprice=0;
    this.extraamounts=0;
  }

  get myForm() {
    return this.form.get('gender');
  }
extraamount:any;

  setAll(objval:any,id:any)
  {
    this.extraamounts=0;
    for(var i=0;i<this.respbyDatasss.length;i++)
    {
      if(objval.target.checked==true)
      {
        if(this.respbyDatasss[i].FacilityID==id)
        {
          
          if(this.extraamount==undefined)
          {
            this.extraamount=this.respbyDatasss[i].Amount;
            this.extraamounts=this.extraamount;
          }
          else {
            this.extraamount=this.extraamount + this.respbyDatasss[i].Amount;
            this.extraamounts=this.extraamount;
          }
          
        }

      }
      else
      {
        if(this.extraamount!=undefined)
        {
          if(this.respbyDatasss[i].FacilityID==id)
        {
          
          this.extraamount=this.extraamount - this.respbyDatasss[i].Amount;
          this.extraamounts=this.extraamount;
          
        }
         
        }

      }
     

    }
// if(this.extraamount!=undefined)
// {
//   this.finalprice =this.extraamounts;
// }
    
    

  }

  respData:any;
  resprolesData:any;
  isEmpty:any;
  Getroomscategories(id:any) {
    this.respData = [];
    this.resprolesData=[];
    this.apiService.getroomcategories(id)
      .then((data) => {
        console.log(data);
        this.respData = data;
        for (var j = 0; j < this.respData[0].length;j++)
         {
          this.isLoading = false;
          this.resprolesData.push({
            "RoomcategoryId": this.respData[0][j].RoomcategoryId,
            "CategoryName": this.respData[0][j].CategoryName

          })
         }
       

      })
      .then(() => {
        if (this.respData.length === 0) {
          this.isEmpty = true;
        } else {
          this.isEmpty = false;
        }
      })
      .catch(err => console.log(err))
  }

  resproomtypeData:any;
  resproomtypesData:any;
  
  Getroomstypes(id:any,RoomcategoryId:any) {
    this.resproomtypeData = [];
    this.resproomtypesData=[];
    this.apiService.getroomtypes(id,RoomcategoryId)
      .then((data) => {
        console.log(data);
     
        this.resproomtypeData = data;
        if(this.resproomtypeData[0].length>0)
        {
          this.isroomtypes=true;
       
        for (var j = 0; j < this.resproomtypeData[0].length;j++)
         {
          this.resproomtypesData.push({
            "Roomtypeid": this.resproomtypeData[0][j].Roomtypeid,
            "RoomTypeName": this.resproomtypeData[0][j].RoomTypeName,
            "TypeAmount":this.resproomtypeData[0][j].TypeAmount

          })
         }
       
        }
        else
        {
          this.isroomtypes=false;
          this.toastr.error('Rooms Types Not Available !', '', {
            timeOut: 2000
          });
        }
      })
      .then(() => {
        if (this.respData.length === 0) {
          this.isEmpty = true;
        } else {
          this.isEmpty = false;
        }
      })
      .catch(err => console.log(err))
  }

  onbookingtypeClick()
  {
    if(sessionStorage['CategoryroomId']!="" && this.form.value.roomcategytype!="")
    {
      this.Getroomstypes(this.strClientid,sessionStorage['CategoryroomId']);
    }
   
  }

  oncategoryroomsClick(id :any)
  {
    sessionStorage['CategoryroomId']=id;
    if(this.form.value.bookingype=="")
    {
      this.isroomtypes=false;
      this.toastr.error('Please Select Booking Type !', '', {
        timeOut: 2000
      });

    }else
    {
      this.Getroomstypes(this.strClientid,sessionStorage['CategoryroomId']);
     
    }
  }

  onroomtypeClick(objamount:any)
  {
    if(this.form.value.roomcategytype=="")
    {
      this.toastr.error('Please Select Category Rooms !', '', {
        timeOut: 2000
      });

    }
    else
    {
      this.bookingprice=objamount;
      this.finalprice=objamount;
    }
   
  }

  get f(): { [key: string]: AbstractControl } {
    return this.form.controls;
  }
  get m(){
    return this.form.controls;
  }
  
 

  userbyObjs:any ;
  respbyDatas:any ;
  respbyDatass:any;
  respbyDatasss:any;
  respbybaseeminity:any;

  getbyFacilitiesid(id:any) {
    this.respbyDatas = [];
    this.respbyDatasss=[];
    this.respbybaseeminity=[];
    this.apiService
      .getfacilities(id)
      .then((data) => {
        console.log(data);
        this.respbyDatass = data;
        for (var j = 0; j < this.respbyDatass[0].length;j++)
         {
          if(this.respbyDatass[0][j].Amount!=0)
          {
            this.respbyDatasss.push({
              "FacilityID": this.respbyDatass[0][j].FacilityID,
              "FacilityName": this.respbyDatass[0][j].FacilityName,
              "Amount":this.respbyDatass[0][j].Amount
  
            })

          }else if(this.respbyDatass[0][j].Amount==0)
          {
            this.respbybaseeminity.push({
              "FacilityID": this.respbyDatass[0][j].FacilityID,
              "FacilityName": this.respbyDatass[0][j].FacilityName,
              "Amount":this.respbyDatass[0][j].Amount
  
            })

          }
          
         }
        // this.respbyDatasss = this.respbyDatass[0];
    
        // this.roomtype=this.respbyDatasss[0].Roomid;
        // this.FacilityName=this.respbyDatasss[0].FacilityName;
        // this.FacilityDescription=this.respbyDatasss[0].FacilityDescription;
        // this.Amount=this.respbyDatasss[0].Amount;
        
      })
      .then(() => {
        if (this.respbyDatas.length === 0) {
          this.isEmpty = true;
        } else {
          this.isEmpty = false;
        }
      })
      .catch((err: any) => console.log(err))

  }
objbookingtype:any;
objroomcategytype:any;
   objroomtypes:any;
    objnoofguests:any;
    objnoofmonths:any;
    roomsflObj:any;
    resprecordset:any;
    resproomtypeDatas:any;
  onSubmit()
  {
    sessionStorage['finalamount']=this.finalprice + this.extraamounts;
   
    this.isSubmitted = true;
    if(this.form.value.typesofrooms!="")
    {
      this.resprecordset=[];
      this.resprecordset=[];
      this.roomsflObj =
    {
      "ClientId":this.strClientid,
      "RoomType":this.form.value.roomcategytype,
      "Roomsharing":this.form.value.typesofrooms
      
    }

      this.apiService.Roomsfloors(this.roomsflObj)
      .then((data) => {
        console.log(data);
        this.resprecordset=data;
        this.resproomtypeDatas = this.resprecordset.recordsets;
        if(this.resproomtypeDatas[0].length>0)
        {
          sessionStorage.roomsfloorslist = JSON.stringify(this.resproomtypeDatas[0]);
         
          this.router.navigate(
            ['/Pghouses/roomallowcation'],
            { queryParams: {bookingtype: this.form.value.bookingype, categorytype: this.form.value.roomcategytype,roomtype:this.form.value.typesofrooms}})
          
        
        }
        else
        {
          this.toastr.error( this.form.value.typesofrooms+' Room And  Floors Not Availables!', '', {
            timeOut: 1000
          });
          
        }
        
  
      })
    
      .catch(err => console.log(err))
 

   
   
    }

    else 
    {
      this.toastr.error('Please Select  Room Types !', '', {
        timeOut: 2000
      });

    }
    //  this.objbookingtype= this.form.value.bookingype;
    // this.objroomcategytype=this.form.value.roomcategytype;
    // this.objroomtypes=this.roomtypes;
    // this.objnoofguests=this.noofguests;
    // this.objnoofmonths=this.noofmonths;

  }

  





}



